<button
  type="button"
  [disabled]="disabled || loading"
  [ngClass]="{
    '!text-blue-mid': loading,
    'border-blue-mid bg-blue-mid': disabled || loading,
    'border-blue bg-blue hover:bg-blue': !disabled && !loading,
  }"
  class="inline-flex w-full items-center justify-center rounded-lg border px-4 py-2 text-white outline-offset-[3px]"
  (click)="handleClick()"
  matRipple
  [matRippleDisabled]="disabled"
>
  @if (loading) {
    <span class="absolute size-6 items-center justify-center">
      <app-loading></app-loading>
    </span>
  }
  @if (type === buttonType.LEADING_ADD_ICON) {
    <mat-icon class="material-icons-outlined mr-2 self-center">add</mat-icon>
  } @else if (icon) {
    <mat-icon class="mr-2 self-center">{{ icon }}</mat-icon>
  }

  <span
    class="self-center text-base font-medium"
    [ngClass]="type === buttonType.LEADING_ADD_ICON ? 'text-sm' : 'text-base'"
  >
    {{ text }}
  </span>
  @if (type === buttonType.TRAILING_LINK_ICON) {
    <mat-icon class="material-icons-outlined ml-2 text-base"
      >arrow_outward</mat-icon
    >
  } @else if (type === buttonType.TRAILING_OPEN_ICON) {
    <mat-icon class="material-icons-outlined text-base"
      >keyboard_arrow_right</mat-icon
    >
  }
</button>
